import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseModel from "../../core/BaseModel";
import { TileLayer } from "../tileLayer/TileLayer";
import { MapTileLayer } from "../tileLayer/MapTileLayer";

var TileModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(TileModel, _BaseModel);

  var _super = _createSuper(TileModel);

  function TileModel() {
    _classCallCheck(this, TileModel);

    return _super.apply(this, arguments);
  }

  _createClass(TileModel, [{
    key: "getUninforms",
    value: function getUninforms() {
      return {};
    }
  }, {
    key: "getTileLayer",
    value: function getTileLayer(usage) {
      switch (usage) {
        case 'basemap':
          return MapTileLayer;

        default:
          return TileLayer;
      }
    }
  }, {
    key: "initModels",
    value: function initModels() {
      var source = this.layer.getSource();

      var _this$layer$getLayerC = this.layer.getLayerConfig(),
          usage = _this$layer$getLayerC.usage;

      if (source !== null && source !== void 0 && source.data.isTile && !this.layer.tileLayer) {
        var tileLayer = this.getTileLayer(usage);
        this.layer.tileLayer = new tileLayer({
          parent: this.layer,
          rendererService: this.rendererService,
          mapService: this.mapService,
          layerService: this.layerService,
          pickingService: this.pickingService,
          transforms: source.transforms
        });
      }

      return this.buildModels();
    }
  }, {
    key: "clearModels",
    value: function clearModels() {}
  }, {
    key: "buildModels",
    value: function buildModels() {
      return [];
    }
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {//
    }
  }]);

  return TileModel;
}(BaseModel);

export { TileModel as default };